import React from 'react';
import { useSelector } from 'react-redux';

import './LandingPageForms.scss';

import getTransactionLandingForms from './LandingPageFormsContent';
import { getProductTypes } from '../../../redux/modules/productTypes/productType.selectors';
import { toLowerKebabCase } from '../../../utils/utils';

const LandingPageForms = () => {
  const userProductTypes = useSelector(getProductTypes);
  const forms = getTransactionLandingForms({ ...userProductTypes });
  return (
    <div className="landing-page-forms-container">
      <div className="container">
        <h4 className="landing-page-forms-title">Forms</h4>
        <div className="e2e-form-list landing-page-forms-form-list">
          {forms.map(({ link, title }) => (
            <a
              className="college-branded-link landing-page-forms-form"
              href={link}
              key={title}
              id={`landing-page-forms-${toLowerKebabCase(title)}-link`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {title}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandingPageForms;
